var render = function render(){var _vm=this,_c=_vm._self._c;return _c('confirmation-modal',{attrs:{"modalId":"log-out","confirmationAction":_vm.logout}},[_c('template',{slot:"header"},[_c('h4',{staticClass:"modal-title mb-0"},[_vm._v(_vm._s(_vm._T('Logging Out')))])]),_c('template',{slot:"body"},[_c('h6',[_vm._v(_vm._s(_vm._T('Do you really want to logout?')))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }